module.exports = __webpack_public_path__ + "assets/contrastIcon-c52a01.svg";